import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendEstablishSessionForOAuthResult,
  BackendMutationEstablishSessionForOauthArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation EstablishSessionForOauth($oauth2Consent: String!) {
    establishSessionForOauth(oauth2Consent: $oauth2Consent) {
      redirectUrl
    }
  }
`;

type Variables = BackendMutationEstablishSessionForOauthArgs;
type Result = BackendEstablishSessionForOAuthResult;

export const establishSessionForOAuth = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: { credentials: 'include' },
  });
  return getSingleProp<Result>(result.data);
};
